import { getTimeout } from '@/helpers/globals.ts'

export async function delay(time: number): Promise<void> {
    const { setTimeout } = getTimeout() ?? { setTimeout: undefined }

    if (setTimeout) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, time)
        })
    }

    return Promise.resolve()
}

export async function delayData<T>(
    data: T | PromiseLike<T>,
    time: number
): Promise<T> {
    const { setTimeout } = getTimeout() ?? { setTimeout: undefined }

    if (setTimeout) {
        return new Promise((resolve) => {
            return setTimeout(() => {
                resolve(data)
            }, time)
        })
    }

    return Promise.resolve(data)
}

/**
 * @internal
 */
export async function delayServer(time: number): Promise<void> {
    return new Promise((resolve) => {
        // eslint-disable-next-line no-restricted-globals
        setTimeout(() => {
            resolve()
        }, time)
    })
}

/**
 * @internal
 */
export async function delayDataServer<T>(
    data: T | PromiseLike<T>,
    time: number
): Promise<T> {
    return new Promise((resolve) => {
        // eslint-disable-next-line no-restricted-globals
        return setTimeout(() => {
            resolve(data)
        }, time)
    })
}
